import React, { useRef, useContext, useLayoutEffect, useState, useMemo } from "react";
import MapContext from "../MapContext";
import "./LinkedMaps.css";
import { BiChevronDown, BiMapAlt } from "react-icons/bi";
import { Popup } from "@progress/kendo-react-popup";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Google } from "./Google";
import { Eagle } from "./Eagle";
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { getCookie } from "../../api/axios";
import { makeArray } from "../../permissionUtils";

const LinkedMaps = () => {
    const { map } = useContext(MapContext);
    const [activeMaps, setActiveMaps] = useState({});
    const [activeWindows, setActiveWindows] = useState({});
    const [selectorToggle, setSelectorToggle] = useState();
    const selectorAnchor = useRef();
    const token = getCookie("ast");
    const roles = token ? jwt_decode(token)?.realm_access?.roles : ["GUEST"];
    const thirdPartyMaps = useSelector((state) => state.configData.thirdPartyMaps);
    const eagleView = thirdPartyMaps?.Eagleview;
    const googleMaps = thirdPartyMaps?.GoogleStreetView;

    const openMapSelector = () => {
        setSelectorToggle(!selectorToggle);
    };

    const updateViews = (e) => {
        const newActiveMaps = { ...activeMaps };
        newActiveMaps[e.target.name] = e.value;
        setActiveMaps(newActiveMaps);
    };
    const toggleWindow = (e) => {
        const newActiveWindows = { ...activeWindows };
        newActiveWindows[e.target.props.name] = false;
        console.log(e);
        setActiveWindows(newActiveWindows);
    };

    // get the projection from the map
    const projection = useMemo(() => {
        const projection = map.getView().getProjection().getCode();
        return projection;
    }, []);

    // start at center of view
    const startingPoint = useMemo(() => {
        const center = map.getView().getCenter();
        return center;
    }, []);

    useLayoutEffect(() => {
        const maps = {};
        const google = authorizeMap(googleMaps, "google", roles);
        Object.assign(maps, google);
        const eagle = authorizeMap(eagleView, "eagle", roles);
        Object.assign(maps, eagle);
        const windows = {};
        for (const key in maps) {
            const newObj = { [key]: !maps[key] };
            Object.assign(windows, newObj);
        }
        setActiveMaps(maps);
        setActiveWindows(windows);
    }, []);

    return (
        <div className="splitter" id="linked-maps-view">
            {Object.keys(activeMaps).length > 1 ? (
                <header className="linked-maps-header">
                    <BiMapAlt style={{ padding: "0 8px" }} />{" "}
                    <div
                        className="select-maps"
                        onClick={openMapSelector}
                        ref={selectorAnchor}>
                        Change Views
                        <BiChevronDown size={20} style={{ bottom: "0" }} />
                    </div>
                </header>
            ) : null}
            <div className="linked-maps">
                {activeMaps?.google ? (
                    activeWindows?.google ? (
                        <Window
                            className="linked-map-window"
                            title={"Google Street View"}
                            onClose={toggleWindow}
                            name={"google"}>
                            <Google
                                startingPoint={startingPoint}
                                projection={projection}
                                setActiveMaps={setActiveMaps}
                                activeMaps={activeMaps}
                                setActiveWindows={setActiveWindows}
                                activeWindows={activeWindows}
                            />
                            <WindowActionsBar>Test</WindowActionsBar>
                        </Window>
                    ) : (
                        <div className="linked-map">
                            <Google
                                startingPoint={startingPoint}
                                projection={projection}
                                setActiveMaps={setActiveMaps}
                                activeMaps={activeMaps}
                                setActiveWindows={setActiveWindows}
                                activeWindows={activeWindows}
                            />
                        </div>
                    )
                ) : null}
                {activeMaps?.eagle ? (
                    activeWindows?.eagle ? (
                        <Window
                            className="linked-map-window"
                            title={"Eagle View"}
                            onClose={toggleWindow}
                            name={"eagle"}>
                            <Eagle
                                setActiveMaps={setActiveMaps}
                                activeMaps={activeMaps}
                                setActiveWindows={setActiveWindows}
                                activeWindows={activeWindows}
                                projection={projection}
                                startingPoint={startingPoint}
                            />
                        </Window>
                    ) : (
                        <div className="linked-map">
                            <Eagle
                                setActiveMaps={setActiveMaps}
                                activeMaps={activeMaps}
                                setActiveWindows={setActiveWindows}
                                activeWindows={activeWindows}
                                projection={projection}
                                startingPoint={startingPoint}
                            />
                        </div>
                    )
                ) : null}
            </div>
            <Popup
                anchor={selectorAnchor.current}
                show={selectorToggle}
                popupClass={"select-maps-popup"}>
                <Checkbox
                    label={"Google Street View"}
                    name={"google"}
                    onChange={updateViews}
                    checked={activeMaps?.google}
                />
                <Checkbox
                    label={"Eagle View"}
                    name={"eagle"}
                    onChange={updateViews}
                    checked={activeMaps?.eagle}
                />
                {/* <Checkbox label={'Bing View'} value={'bing'} onChange={updateViews}/> */}
            </Popup>
        </div>
    );
};

export default LinkedMaps;

const authorizeMap = (thirdPartyMap, name, roles) => {
    const maps = {};
    if (thirdPartyMap?.Enabled) {
        const permissions = thirdPartyMap.Permissions?.Allow;
        if (permissions) {
            makeArray(permissions).forEach((p) => {
                if (roles.includes(p.Value)) {
                    Object.assign(maps, { [name]: true });
                }
            });
        } else {
            Object.assign(maps, { [name]: true });
        }
    }
    return maps;
};
